/*
 * fn: stripExtraSpaces
 *
 * Removes extra spaces from the front and end and multiple spaces
 *
 */
export const stripExtraSpaces = (input: string | undefined) => input?.replace(/\s+/g, ' ').trim() || ''
